import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationConfig } from '@aodocs/authentication';
import { ConfigurationService } from '@aodocs/configuration-service';
import { LoginPageConfig } from '@aodocs/login-page';
import { AttachmentPreviewConfig } from '@aodocs/models';

export abstract class FactoriesUtils {
  static initializeConfiguration(path: string, configurationService: ConfigurationService<AttachmentPreviewConfig>) {
    return (): Promise<AttachmentPreviewConfig> => configurationService.load(path);
  }

  static initializeLoginPageConfiguration(): LoginPageConfig {
    return {
      redirectUrl: ['/', 'preview'],
      additionalScopesFactory: (activatedRoute: ActivatedRoute): string[] => activatedRoute.snapshot.queryParams['scope']?.split(' '),
    };
  }

  static initializeAuthenticationConfiguration(configurationService: ConfigurationService<AttachmentPreviewConfig>): AuthenticationConfig {
    return {
      apiKey: configurationService.configuration.firebaseApiKey,
      authDomain: configurationService.configuration.firebaseAuthDomain,
      authAppName: 'attachment-preview-auth',
      storageKey: 'aodocs-attachment-preview',
      authProviderUrl: configurationService.configuration.aodocsAuthProviderUrl,
      createUrlTree: (router: Router) =>
        router.createUrlTree(['login'], { queryParams: router.getCurrentNavigation()?.initialUrl.queryParams }),
    };
  }
}
